module.exports = __webpack_public_path__ + "img/passport.41f7e2e2.png";